import { render, staticRenderFns } from "./Products.vue?vue&type=template&id=fef743f8&scoped=true"
import script from "./Products.vue?vue&type=script&lang=js"
export * from "./Products.vue?vue&type=script&lang=js"
import style0 from "./Products.vue?vue&type=style&index=0&id=fef743f8&prod&scoped=true&lang=stylus"
import style1 from "./Products.vue?vue&type=style&index=1&id=fef743f8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fef743f8",
  null
  
)

export default component.exports